import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
    id: string;
    message: string;
    type: ToastType;
    duration: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
    readonly toasts = signal<Toast[]>([]);

    show(message: string, type: ToastType = 'success', duration = 3000): void {
        const id = crypto.randomUUID();
        this.toasts.update((current) => [...current, { id, message, type, duration }]);
        setTimeout(() => this.removeById(id), duration);
    }

    removeById(id: string): void {
        this.toasts.update((current) => current.filter((t) => t.id !== id));
    }
}
